import {udLink} from '@udemy/ud-data';

import {Topic, Topics} from '../../types';
import {shuffle} from './shuffle';
import topicData from './topic-data.json';

const TOPIC_TYPE_POPULAR = 'popular';
const TOPIC_TYPE_TRENDING = 'trending';
export {TOPIC_TYPE_POPULAR, TOPIC_TYPE_TRENDING};

export class FeaturedTopicsUnitStore {
    constructor() {
        this.topicData = shuffle(topicData.unit.items) as Topics;
        this.topicData.forEach((topic) => {
            topic.imageUrl = udLink.toStorageStaticAsset(
                `browse_components/featured-topic-unit/${topic.key}.jpg`,
            );
        });
        this.unitType = 'featured_topics_unit';
        this.unit = {item_type: 'featured_topics'};
    }

    private topicData: Topics;
    unitType: string;
    unit: {
        item_type: string;
    };

    get topics(): Topics {
        const trendingTopics: Topics = [];
        const popularTopics: Topics = [];

        // Sort into two piles
        this.topicData.forEach((topic) => {
            if (topic.type === TOPIC_TYPE_TRENDING) {
                trendingTopics.push(topic);
            } else {
                popularTopics.push(topic);
            }
        });

        // Alternate picking from each pile until one pile becomes empty
        const result: Topics = [];
        let collection = popularTopics;
        while (trendingTopics.length > 0 && popularTopics.length > 0) {
            result.push(collection.pop() as Topic);
            if (collection === trendingTopics) {
                collection = popularTopics;
            } else {
                collection = trendingTopics;
            }
        }

        return result;
    }
}
